import { post, get } from "../../libs/ajax.js"
// 排单排期 v2 · 引擎类接口（待排单池 / 预排结果 / 一键预排 / 产能水位 / 置换预览）
// 阶段16·Task11：本文件只留「引擎类」，操作类（adjust/swap/regroup/batch_*/confirm）全部下放 schedule_manage（见 scheduleManage.js）

// 下单排期预览（水位+推荐交付日）
export function getCreateSchedulePreview(data) {
  return post('/work_order/create/schedule_preview', data)
}

export default {
  // 待排单池(status=0)
  getSchedulingPool: (data, options) => {
    return post("/work_order/scheduling/pool", data, options)
  },
  // 预排结果(status=1)
  getSchedulingResult: (data, options) => {
    return post("/work_order/scheduling/result", data, options)
  },
  // 筛选选项
  getSchedulingOptions: (data, options) => {
    return post("/work_order/scheduling/options", data, options)
  },
  // 产能水位（期望完成日×大类组）
  getSchedulingWater: (data, options) => {
    return post("/work_order/scheduling/water", data, options)
  },
  // 一键自动预排（弹框选期望完成时间范围 [range_from, range_to]，可空=全量·负责人专属·阶段16不变）
  preSchedule: (data, options) => {
    return post("/work_order/scheduling/preschedule", data, options)
  },
  // 置换预览（只读·返置换后两叶组当天 used/cap/是否超标·引擎上下文留用）
  swapPreviewScheduling: (data, options) => {
    return post("/work_order/scheduling/swap_preview", data, options)
  },

  // 自定义筛选条件 —— get/edit（custom_field 复用 material.js 的 getCustomField/editCustomField）
  getSchedulingFilter: (data, options) => {
    return get("/custom_filter/get", data, options)
  },
  editSchedulingFilter: (data, options) => {
    return post("/custom_filter/edit", data, options)
  },
}
